import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@insurancemenu/imenu-components-lib';
import { Reload } from '@insurancemenu/imenu-components-lib/dist/icons';
import ICensusReviewPageStore, { CensusReviewDomainParams } from 'store/modules/census/iCensusReviewPageStore';
import { ActionSectionStyled, ErrorMessageStyled, ErrorSectionStyled, ErrorTitleStyled } from './styles';
import { INCOMPATIBILITY_ERROR_TEST_ID, INCOMPATIBILITY_ERROR_REUPLOAD_BUTTON_TEST_ID } from '../constants';

interface Props {
  pageStore: ICensusReviewPageStore<CensusReviewDomainParams>;
}

const IncompatibilityError: React.FC<Props> = observer(({ pageStore }) => {
  const { incompatibilityErrorMsg, onBackRedirect } = pageStore;

  return (
    <ErrorSectionStyled data-test-id={INCOMPATIBILITY_ERROR_TEST_ID}>
      <ErrorTitleStyled>We couldn&apos;t process your file.</ErrorTitleStyled>
      <ErrorMessageStyled>{incompatibilityErrorMsg}</ErrorMessageStyled>
      <ActionSectionStyled>
        <Button
          onClick={onBackRedirect}
          color="primary"
          size="large"
          leftIconProp={<Reload />}
          data-test-id={INCOMPATIBILITY_ERROR_REUPLOAD_BUTTON_TEST_ID}
        >
          Re-upload Census
        </Button>
      </ActionSectionStyled>
    </ErrorSectionStyled>
  );
});

export default IncompatibilityError;
